module.exports = __webpack_public_path__ + "c_static/img/122.1cf8a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/122.png
// module id = 8CBu
// module chunks = 33